import { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';

import { GlobalService } from './global.service';

import { AXIOS, CommonGlobalService, UUID, CallbackErrorAxios, CallbackWarningAxios } from '@umanforge/common';
import { Warning } from 'interfaces/warning.interface';
import { API } from 'constants/api.contants';


export class WarningService {

  static getWarningsByPlanningId(
    planningId: UUID,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<Warning[]> {
    return new Promise( async resolve => {
      AXIOS.get( `${API.WARNING_BY_PLANNING}/${planningId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<Warning[]> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }
};